import styled from "@emotion/styled";

export const ReplacementsHeaderWrapper = styled.div(({ theme }) => ({
	backgroundColor: theme.project.colors.backgroundColors.main,
	padding: 24
}));
